import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { campaignAction } from "../../../store/campaign-store";
import { templateAction } from "../../../store/template-store";
import { cuteToast } from "../../UI/cute";
import { getSubdomain } from "../../../helpers/helpers";
// import { cuteToast } from "../../UI/cute";
import "./template.css";
const ListScens = () => {
  const history = useHistory();
  const camp_id = useSelector((state) => state.campaign.camp_id);
  const [scene_id, setScene_id] = useState([]);
  const dispatch = useDispatch();
  const is_scene_loaded = useSelector(
    (state) => state.template.is_scene_loaded
  );
  const scene_data = useSelector((state) => state.template.scene_data);
  const video_data = useSelector((state) => state.campaign.video_data);
  const active_slide_type = useSelector((state) => state.campaign.active_slide_type);

  const myAccess = useSelector((state) => state.auth.access);
  const token = useSelector((state) => state.auth.token);
  const { sendRequest } = useHttp();
  const checkaccess =  (access) => myAccess.includes(access); 

    // ----------------------------

    useEffect( () => {
      const responseData = (response) => {
        // console.log(response);
  
        if (response.body) {
          // console.log(response.body);
          var sceneData = [];
          var i = 0;
          response.body.map( async (items) => {
            
            // console.log(items.temp_type);
            var template_data = JSON.parse(items.slide_data);
            // console.log(template_data);

            template_data.map((item) => {
              // console.log(item);
              i++;

                const temp = {
                                "id": i,
                                "name": items.name,
                                "type": items.temp_type,
                                "thumbnail_url": null,
                                "preview_url": null,
                                "status": items.status,
                                "slides_url": null,
                                "slide_data": JSON.stringify(item),
                                "createdAt": items.createdAt,
                                "updatedAt": items.updatedAt,
                                "template_id": items.main_id,
                                "template_access": items.access
                            };
              if(myAccess.includes('5') || myAccess.includes('9S'))
              {
                sceneData.push(temp);
              }else{
                if(items.status === 1 && items.access.split(',').filter(Boolean).some(checkaccess) )
                {
                  sceneData.push(temp);
                }
              }
              
              return null;
            });

            return null;
          });

          // console.log("sceneData");
          // console.log(sceneData);
          dispatch(templateAction.setSceneData({ scene_data: sceneData }));
            
        }
      };
  
      if (!is_scene_loaded) {
  
        var productName = getSubdomain();
        if(productName === "vidwise" || productName === "nicheflick"){
          productName = "vidcraftai";
        }

        const apiUrl = productName ? endPoints.fetchTemplates + "/" + productName : endPoints.fetchTemplates;
        sendRequest(
          {
            url: apiUrl,
            method: "GET",
            headers: {
              "access-control-allow-origin": "*",
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          },
          responseData
        );
      } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, is_scene_loaded, sendRequest]);








  // ------------------------

  useEffect(() => {
    document.title = `Choose Scenes`;
  });

  useEffect(() => {
    if (!camp_id) {
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camp_id]);

  const handleClose = (e) => {
    e.preventDefault();
    history.push(`/campaign/${camp_id}/edit`);
  };

  // useEffect(() => {
  //   const responseData = (response) => {
  //     // console.log(response);

  //     if (response.body) {
  //       // dispatch(templateAction.setSceneData({ scene_data: response.body }));

  //       console.log(response.body);
  //     }
  //   };
  //   if (!is_scene_loaded) {
  //     sendRequest(
  //       {
  //         url: endPoints.fetchScenes,
  //         method: "GET",
  //       },
  //       responseData
  //     );
  //   } else {
  //   }
  // }, [dispatch, is_scene_loaded, sendRequest]);

  const playMovie = (e) => {
    e.target.play();
    // console.log(e);
    e.target.muted = true;
  };

  const stopMovie = (e) => {
    e.target.pause();
    e.target.load();
  };

  const handleSelectScene = (id) => {
    if (scene_id.includes(id)) {
      var new_scene_ids = scene_id.filter((scene) => scene !== id);
      setScene_id(new_scene_ids);
    } else {
      if (parseInt(video_data.length) + parseInt(scene_id.length) >= 15) {
        cuteToast({
          type: "error",
          message: "",
          timer: 5000,
          title: "Scene max limit is 15",
        });
        return false;
      }
      setScene_id([...scene_id, id]);
    }
  };

  // Unselect all selected scene(slides)
  const handleDeselect = () => {
    setScene_id([]);
  };

  // append or add selected slide(scene)
  const handleInsertScene = () => {
    var new_video_data = [...video_data];
    scene_id.map((id) => {
      scene_data.filter((single) => {
        if (single.id === id) {
          var assets = JSON.parse(single.slide_data);
          new_video_data.push(assets);
          return true;
        } else {
          return false;
        }
      });
      return null;
    });

    dispatch(campaignAction.setVideoData({ video_data: new_video_data }));
    setScene_id([]);
    history.push(`/campaign/${camp_id}/edit`);
  };


  var scenes_loaded = 0;


  return (
    <div className="templateList">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 p-10-12 border-1">
            <a
              href="#0"
              className=" pull-right text-gray"
              onClick={(e) => handleClose(e)}
            >
              Close
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="16"
                height="16"
                viewBox="0 0 50 50"
                style={{ fill: "rgb(0 0 0 / 49%)" }}
              >
                <path d="M 7.7070312 6.2929688 L 6.2929688 7.7070312 L 23.585938 25 L 6.2929688 42.292969 L 7.7070312 43.707031 L 25 26.414062 L 42.292969 43.707031 L 43.707031 42.292969 L 26.414062 25 L 43.707031 7.7070312 L 42.292969 6.2929688 L 25 23.585938 L 7.7070312 6.2929688 z"></path>
              </svg>
            </a>
          </div>
          <div className="col-sm-12 p-10-12 bg-light-gray pb-5 mb-5">
            <div className="container">
              <div className="row">
                {scene_data &&
                  scene_data.length > 0 && (scenes_loaded === 0) &&
                  scene_data.map((singlescene, index) => {
                    const id = singlescene.id;
                    const single_scene = JSON.parse(singlescene.slide_data);

                    if( singlescene.type !== active_slide_type){
                      return (null);
                    // }else{
                    //   console.log(singlescene.type, active_slide_type);
                    }

                    if(scenes_loaded >= 30){
                      return null;
                    }

                    scenes_loaded++;
                    console.log(scenes_loaded); 

                    return (
                      <div className="col-sm-4" key={index}>
                        <div
                          className={`singleScene ${
                            scene_id.includes(id) ? "active" : ""
                          }`}
                          onClick={(e) => handleSelectScene(id)}
                        >
                          <div className="scene_video">
                            {scene_id.includes(id) && (
                              <div className="scene_counter">
                                {scene_id.indexOf(id) + 1}
                              </div>
                            )}
                            <video
                              src={single_scene.preview_url}
                              poster={single_scene.thumbnail}
                              //   preload="none"
                              loop
                              height="100%"
                              width="100%"
                              onMouseOver={playMovie}
                              onMouseOut={stopMovie}
                            />
                          </div>
                          <div className="scene_title">
                            scene {parseInt(index + 1)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="col-sm-12 insertDiv">
            <button
              className="btn ms-auto pull-right"
              disabled={scene_id.length === 0 ? true : false}
              onClick={handleInsertScene}
            >
              Insert
            </button>

            {scene_id.length > 0 && (
              <a
                className="ms-auto pull-right scene_deslect"
                href="#0"
                onClick={handleDeselect}
              >
                Deselect Slide
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListScens;
